<template>


        <v-card 
        elevation="2"
        shaped
        class="ma-1"
        >
        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Paramétrages généraux </v-tab>
          <v-tab> requetes pour jonction </v-tab>
          <v-tab> Modules de recherche</v-tab>
          <v-tabs-items v-model="tab" class="pl-4">
            <v-tab-item>
                <v-row>
                    <v-col class="ma-1">
              <v-btn @click="openBibliothequeModule('new')"
                >Créer un module bibliothèque</v-btn>                      
                        <Select
                        :item="item"
                        :change="(item,value) => { displays.params.bibliothequemodule = value.value}"
                        :valField="displays.params.bibliothequemodule"
                        />  

                        <TextField                  
                        :item="{name:'Zoom',format:'number',value:'zoom',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {displays.params.zoom = value } "
                        :valField="displays.params.zoom"/>

                        <TextField                  
                        :item="{name:'hauteur de la carte',value:'height',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {displays.params.height = value } "
                        :valField="displays.params.height"/>

                        <div v-if="displays.params.bibliothequemodule!=''">

              <v-btn @click="openBibliothequeModule(displays.params.bibliothequemodule)"
                >Editer le module bibliothèque</v-btn>

                        <component v-bind:is="$modules.bibliotheque.components.client"
                        v-if="displays.params.bibliothequemodule"
                        :key="displays.params.bibliothequemodule"  
                        :mod="false"
                        :idmodule="displays.params.bibliothequemodule" 
                        :modal="false"
                        :modalKey="modalKey"
                        :page="page"
                        :customparams="{allowselect:true}"
                        :form="false"
                        />                            

                        </div>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item>

                <v-btn fab small @click="addListe"><v-icon>mdi-plus</v-icon></v-btn>
                <v-expansion-panels variant="popout" v-model="listQuerys" class="pa-3">
                <v-expansion-panel v-for="(query, i) in displays.params.querys" :key="'lf'+i">
                    <v-expansion-panel-header>
                    requete : {{query.description}}
                    <template v-slot:actions>
                        <v-btn icon @click="removeListe(i)" v-if="query.key!='default'"><v-icon>mdi-close-thick</v-icon></v-btn>
                    </template> 
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="grey lighten-3">

                    <div>
                        <TextField                  
                        :item="{name:'description',value:'description',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.description = value } "
                        :valField="query.description"/>
                        <TextField                  
                        :item="{name:'url de l\'icone',value:'iconurl',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.iconurl = value } "
                        :valField="query.iconurl"/>
                        <TextField                  
                        :item="{name:'largeur',value:'iconwidth',format:'number',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.iconwidth = value } "
                        :valField="query.iconwidth"/>
                        <TextField                  
                        :item="{name:'hauteur',value:'iconheight',format:'number',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {query.iconheight = value } "
                        :valField="query.iconheight"/>
                        <Select
                        :item="{name: 'table ciblée',value: 'table',liste: listTables,
                        defaultprops:{ show: true,clearable:true } } "
                        :change="(item,value) => { query.table = value?.value || ''; } "
                        :valField="query.table"
                        />             
                    </div>

                    <v-tabs v-model="tabsFiche" v-if="query.table && query.table!=''">
                        <v-tab> Filtre </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tab> mappage des résultats </v-tab>
                        <v-tab> encart pour détails </v-tab>
                        <v-tab> actions affiliées </v-tab>
                        <v-tabs-items v-model="tabsFiche">
                        <v-tab-item>
                            <Filtre :page="page" :filtre="query.filtre" :table="query.table" />
                        </v-tab-item>
                        <v-tab-item> 
                            <Fields :page="page" :champs="query.champs" :modalKey="modalKey" :filter="query.filtre" :table="query.table" />
                        </v-tab-item>
                        <v-tab-item>
                            <ArrayTable 
                            :item="{otherparams:{arrayTable:[{type:'',key:'key',name:'clé'},{type:'',key:'value',name:'Valeur',description:'(Vous pouvez insérer des variables d\'environnement)'}]},
                            defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'Ajouter une clé'}}"
                            :valField="query.map"
                            :change="(item,model) => { query.map = model; }"
                            />
                        </v-tab-item>
                        <v-tab-item>
                            <CPage 
                            :pageTemplate="query.encart" 
                            :page="page" 
                            :modal="false" 
                            :form="false" 
                            hook=""
                            :mod="true"
                            @recepVal="(array) => {query.encart = array}"
                            />
                        </v-tab-item>
                        <v-tab-item>
                            <Autocomplete :item="{
                            defaultprops:{ show: true, chips:true,multiple:true,deletablechips:true },
                            name: 'actions affichés',
                            value: 'none',
                            liste: listActions,
                            }" :change="(item,value,sel)=> {changeActions(item,value,sel,i) }" :valField="query.actions" />
                        </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>

                    </v-expansion-panel-content>  

                </v-expansion-panel>
                </v-expansion-panels>

                <h3>Actions :</h3>
<listActions :page="page" :module="module" :modalKey="modalKey" @listActions="Actions"/>
            </v-tab-item>

            <v-tab-item>

              <SimpleTable
                :Headers="[
                  { text: 'ID', value: 'id' },
                  { text: 'type', value: 'type' },
                  { text: 'Nom', value: 'name' },
                  { text: 'Table', value: 'table' },
                  { text: 'champs', value: 'champs' },
                ]"
                :datas="dataTableSearch"
                :selected="displays.params.searchmodule"
                keyRow="id"
                @getselected="(data) => { displays.params.searchmodule = data }"
              />            
                  
            </v-tab-item>

            </v-tabs-items>
        </v-tabs>
        </v-card>



</template>



<script>
import  { admin } from '../mixins';
import { openModuleEditor } from '@/components/engine/editModule/navigation'

    export default {
        name : 'MapModule',
        props: ["module", "page",'modalKey',"buildingParameters"],

        mixins : [admin],

        components : {
            
        },

        data: function() {
            return { 
            item : {name:'Module bibliothèque utilisé pour la selection des icones',value:'bibliothequemodule',liste:[],
                defaultprops:{show:true,modelRules:[v => !!v || 'Au moins un champ doit etre renseigné']}},

                displays : this.module.displays,
                tab : '',
                listQuerys : '',
                listTables : [],
                dataTableSearch: [],
                tabsFiche : '',
                listActions : [],
            }
        },

        watch: {
            '$store.getters.getPicture'(val) {
                if (!val || !val.image_url) return

                // éviter de relancer si déjà traité
                if (this.displays.params.file_id === val.image_id) return

                this.displays.params.file_id = val.image_id
                this.displays.params.file_name = val.name
                this.$store.dispatch('removePicture')
            },
        
        },


        methods : {

            openBibliothequeModule(id) {
                openModuleEditor({
                    id,
                    initialType: id === 'new' ? 'bibliotheque' : '',
                    contextKey: this.modalKey,
                    onSaved: module => {
                        if (id === 'new') this.displays.params.bibliothequemodule = module.id
                        this.getBibliModules()
                    },
                })
            },

            getsearchFromAPI() {
            this.API({
                type: "post",
                url: "/engine/module/list",
                params: { type: ["search","echarts"] },
            }).then((resp) => {
                resp.data.forEach((v) => {
                let champs = (v.displays.params.champs) ? v.displays.params.champs.join(", ") : "--";
                this.dataTableSearch.push({
                    id: v.id,
                    type: v.type,
                    name: v.name,
                    table: v.table,
                    champs: champs,
                });
                });
                // pour intégrer la recherche globale :
                this.dataTableSearch.push({
                id: "global",
                champs: "sensible au champ de la recherche globale",
                });
            });
            },


            Actions(datas){
            this.listActions = []
            datas.forEach((v) => {
                this.listActions.push({text:v.name,value:v.id});
            })
            },

            addListe() {
            
                var defaultQ = JSON.parse(JSON.stringify(this.buildingParameters.map.defaultquery));
                this.displays.params.querys.push(defaultQ);
            },

            removeListe(index) {
                this.displays.params.querys = this.displays.params.querys.filter((el,i)=> i!=index);
            },

            getBibliModules() {
                this.item.liste = []
                this.API({ type: 'post', url: "/engine/module/list", params: { type: 'bibliotheque' } }).then((resp) => {
                    resp.data.forEach((v) => {
                    this.item.liste.push({ value: v.id, text: v.name });
                    });
                })
            },

            changeActions(item,value,selectedKey,row) {
            var actions = []
            for(var selected in value) {
                if(typeof value[selected] == 'object') { actions.push(value[selected][selectedKey]) } else { actions.push(value[selected]); }
            }
            this.displays.params.querys[row].actions = actions
            this.$emit('recepVal',this.displays); 
            },
        },
    
        mounted() { 
            
            this.getBibliModules();

            this.getsearchFromAPI();

            this.API({type:'get', url:'engine/getlisttable'}).then((resp) => {
                resp.data.forEach((table) => {
                    this.listTables.push({text:table,value:table})
                })
                
            })            
        }

    }

</script>

